module.exports = __webpack_public_path__ + "media/application/images/2018/2018-mail-icon-f998fa5e8619791e90e64323406ca0af.svg";